import ToastError from "./components/ToastError/ToastError";
import RootRoute from "./views/Routes/RootRoute";
import "./App.scss";
import { useDispatch, useSelector } from "react-redux";
import { setThemeStylesHandler } from "./store/actions/actionHandlers/homeActionHandler";
import { useEffect, useState } from "react";
import { endUserSessionOnPageExit } from "./store/actions/actionHandlers/loginActionHandler";
import { setLTIThemeStyle } from "./utils/setLTIThemeStyle";
import PageLoader from "./components/CommonComponents/PageLoader/PageLoader";
function App() {
  const dispatch = useDispatch();
  const homeState = useSelector((state) => state.homeReducer);
  const { themeStyles } = homeState;
  const errorState = useSelector((state) => state.errorReducer);
  const { loading } = errorState;
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const themeData = JSON.parse(localStorage.getItem("themeData"));
    const tenantName = localStorage.getItem("tenantSlugName");
    if (!!themeData && !!themeStyles === false) {
      dispatch(setThemeStylesHandler());
    }
    if (tenantName !== undefined) {
      dispatch(setLTIThemeStyle());
    }
  }, [dispatch, themeStyles, setLTIThemeStyle]);

  useEffect(() => {
    const ele = document.getElementById("page-loader");
    if (ele || !pageLoaded) {
      ele.outerHTML = "";
      setPageLoaded(true);
    }
  }, [pageLoaded]);

  useEffect(() => {
    const handlePageExit = () => {
      endUserSessionOnPageExit();
    };

    // Use both beforeunload (for navigation) and pagehide + unload (for close/refresh)
    window.addEventListener("beforeunload", handlePageExit);
    window.addEventListener("pagehide", handlePageExit);
    window.addEventListener("unload", handlePageExit);

    return () => {
      window.removeEventListener("beforeunload", handlePageExit);
      window.removeEventListener("pagehide", handlePageExit);
      window.removeEventListener("unload", handlePageExit);
    };
  }, []);


  useEffect(() => {
    const tenantSlugName = localStorage.getItem("tenantSlugName");
    const normalizedTenantSlugName = tenantSlugName?.toLowerCase();
    const link = document.querySelector('link[rel="icon"]');
    if (
      link &&
      (normalizedTenantSlugName === "search" ||
        normalizedTenantSlugName === "qaaadsep26" ||
        normalizedTenantSlugName === "ltimindtree" ||
        normalizedTenantSlugName === "ltm" ||
        normalizedTenantSlugName === "cybersec")
    ) {
      link.setAttribute('href', 'lighthouse_favicon_lti.png');
      document.title = "Lighthouse"
    } else {
      link.setAttribute('href', 'favicon.ico');
      document.title = "Shotclasses"
    }

  }, [themeStyles]);
  console.log("testing");
  return pageLoaded ? (
    <div
      className="App"
    // style={
    //   loading
    //     ? {
    //         height: "100vh",
    //         overflow: "hidden",
    //       }
    //     : {}
    // }
    >
      <RootRoute />
      <ToastError />
      {loading && <PageLoader />}
    </div>
  ) : null;
}

export default App;
